import { useParams, Navigate } from "react-router-dom";
import { DEMOS } from "@/src/data/demos";
import AgenticOSDemoShell from "@/src/components/demos/AgenticOSDemoShell";

// ═══════════════════════════════════════════════════════════════════════
// INTERACTIVE DEMO ROUTE WRAPPER
// ═══════════════════════════════════════════════════════════════════════

export default function InteractiveDemo() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) return <Navigate to="/" replace />;

  const demo = DEMOS.find((d) => d.id === slug);
  if (!demo) return <Navigate to="/" replace />;

  return (
    <div className="w-full h-full overflow-y-auto bg-[#080808]">
      <AgenticOSDemoShell demo={demo} />
    </div>
  );
}
